module.exports = __webpack_public_path__ + "img/11.e643d669.jpg";